import { cloneDeep } from "lodash";

export const injectGuaranteedUserOffer = ({
  offersRef,
  guaranteedUserOffer
}) => {
  for (const plan of offersRef?.[0]?.plans ?? []) {
    if (plan.name !== guaranteedUserOffer.plan_name) {
      continue;
    }

    if (Array.isArray(plan?.currency_offers)) {
      for (let i = 0; i < plan.currency_offers.length; i++) {
        if (plan.currency_offers[i]?.periods === guaranteedUserOffer.periods) {
          // Not exising field in BE response
          plan.currency_offers[i].original_currency_offer = cloneDeep(
            plan.currency_offers[i]
          );
          plan.currency_offers[i].is_guaranteed_user_offer = true;

          plan.currency_offers[i].id = guaranteedUserOffer.id;
          plan.currency_offers[i].offer_amount =
            guaranteedUserOffer.offer_amount;
          plan.currency_offers[i].order_amount =
            guaranteedUserOffer.order_amount;
          plan.currency_offers[i].proration_amount =
            guaranteedUserOffer.proration_amount;
          plan.currency_offers[i].affiliation_discount_amount =
            guaranteedUserOffer.affiliation_discount_amount;
          plan.currency_offers[i].periods = guaranteedUserOffer.periods;
          plan.currency_offers[i].outdated = guaranteedUserOffer.outdated;
          plan.currency_offers[i].description = guaranteedUserOffer.description;
          plan.currency_offers[i].is_special_offer =
            guaranteedUserOffer.is_special_offer;
          plan.currency_offers[i].special_offer_description =
            guaranteedUserOffer.special_offer_description;
          plan.currency_offers[i].reference_amount =
            guaranteedUserOffer.reference_amount;
          plan.currency_offers[i].days = guaranteedUserOffer.days;
          plan.currency_offers[i].expiration_datetime =
            guaranteedUserOffer.expiration_datetime;
          plan.currency_offers[i].seconds_to_expire =
            guaranteedUserOffer.seconds_to_expire;
          plan.currency_offers[i].payment_date =
            guaranteedUserOffer.payment_date;
          plan.currency_offers[i].payment_methods =
            guaranteedUserOffer.payment_methods;
          plan.currency_offers[i].payment_methods_pricing =
            guaranteedUserOffer.payment_methods_pricing;
          plan.currency_offers[i].subscription_methods =
            guaranteedUserOffer.subscription_methods;
          plan.currency_offers[i].revenue_cat_offers =
            guaranteedUserOffer.revenue_cat_offers;
          plan.currency_offers[i].omnibus_price =
            guaranteedUserOffer.omnibus_price;
          return;
        }
      }
    }
  }
};
